// extracted by mini-css-extract-plugin
export var avatarContainer = "_4r-1";
export var largeAvatarContainer = "_4r-2";
export var smallAvatarContainer = "_4r-0";